export const breakpoints = Object.freeze({
  xs: 390, // 모바일
  sm: 512, // 소형 태블릿
  md: 830, // 태블릿
  lg: 1024, // 노트북
  xl: 1280, // 데스크톱
  tablet: 480,
  notebook: 640,
  desktop: 800,
  height: 600,
});
